module.exports = __webpack_public_path__ + "static/media/smart_saving_img.5dbf2823.png";